import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {AppService} from '../app.service';
import {Dotaznik} from '../model/dotaznik';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-mobile-button-bar',
  templateUrl: './mobile-button-bar.component.html',
  styleUrls: ['./mobile-button-bar.component.css']
})
export class MobileButtonBarComponent implements OnInit {

  dotaznikyShow = false;
  poplatkyShow = false;
  messagesShow = false;
  jobMarketShow = false;
  diskusiaShow = false;

  dotaznikyCount = 0;
  poplatkyCount = 0;
  jobMarketCount = 0;
  messageCount = 0;
  diskusiaCount = 0;

  private dotaznikyData: Subscription;
  private jobsData: Subscription;
  private poplatkyData: Subscription;
  private messagesData: Subscription;
  private diskusiaData: Subscription;

  constructor(
      private appService: AppService,
      @Inject(LOCALE_ID) private locale: string,
      private translate: TranslateService
  ) {
  }

  ngOnInit(): void {

    this.dotaznikyData =
        this.appService.dotaznikyData
            .subscribe((data: Dotaznik[]) => {
              this.dotaznikyCount = data.length;
            });

    this.poplatkyData = this.appService.poplatkyData
        .subscribe((data) => {
          this.poplatkyCount = data.length;
        });

    this.jobsData = this.appService.jobsData
        .subscribe((data) => {
          this.jobMarketCount = data.length;
        });

    this.messagesData = this.appService.messagesData
        .subscribe((data) => {
          let count = 0;
          if (data) {
            data.forEach((m) => {
              count += m.messages.length;
            });
          }
          this.messageCount = count;
        });

    this.diskusiaData = this.appService.diskusiaData
      .subscribe((data) => {
        let count = 0;
        if (data) {
          data.forEach((i) => {
            count += i.pocet;
          });
        }
        this.diskusiaCount = count;
      });
  }

  onDotaznikyClick() {
    if (this.dotaznikyCount > 0) {
      this.dotaznikyShow = !this.dotaznikyShow;
      this.appService.onDotaznikyClickSubject.next(this.dotaznikyShow);
    }
    else {
      this.appService.openErrorDialog(
          this.translate.instant('Aktuálne pre vás v systéme nie sú zaevidované žiadne dotazníky.')
      );
    }
  }

  onDiskusiaClick() {
    if (this.diskusiaCount > 0) {
      this.diskusiaShow = !this.diskusiaShow;
      this.appService.onDiskusiaClickSubject.next(this.diskusiaShow);
    }
    else {
      this.appService.openErrorDialog(
          this.translate.instant('ziadne_temy_diskusie')
      );
    }
  }

  onPoplatkyClick() {
    if (this.poplatkyCount > 0) {
      this.poplatkyShow = !this.poplatkyShow;
      this.appService.onPoplatkyClickSubject.next(this.poplatkyShow);
    }
    else {
      this.appService.openErrorDialog(
          this.translate.instant('Aktuálne pre vás v systéme nie sú zaevidované žiadne poplatky.')
      );
    }
  }

  onMessagesClick() {
    if (this.messageCount > 0) {
      this.messagesShow = !this.messagesShow;
      this.appService.onMessagesClickSubject.next(this.messagesShow);
    }
    else {
      this.appService.openErrorDialog(
          this.translate.instant('Aktuálne pre vás v systéme nie sú zaevidované žiadne správy.')
      );
    }
  }

  onJobMarketClick() {
    if (this.jobMarketCount > 0) {
      this.jobMarketShow = !this.jobMarketShow;
      this.appService.onJobMarketClickSubject.next(this.jobMarketShow);
    }
    else {
      this.appService.openErrorDialog(
          this.translate.instant('Aktuálne pre vás v systéme nie sú zaevidované žiadne pracovné ponuky.')
      );
    }
  }

  openRozvrh() {
    window.location.href = '/ais/apps/rozvrh/' + this.locale + '/';
  }

}
